import { heroById, type HeroTemplateId } from '@/data/heroes';
import { type Party } from '@/game/party';

export class PartyPanel {
  private readonly el: HTMLElement;
  private readonly list: HTMLElement;
  private onPromote: ((id: HeroTemplateId) => void) | null = null;

  constructor(root: HTMLElement) {
    this.el = root;
    const list = root.querySelector<HTMLElement>('.party-list');
    if (list === null) throw new Error('party-panel: missing .party-list');
    this.list = list;
    this.list.addEventListener('click', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLElement)) return;
      const li = target.closest<HTMLLIElement>('li[data-template-id]');
      if (li === null) return;
      const id = li.dataset.templateId;
      if (id !== undefined) this.onPromote?.(id as HeroTemplateId);
    });
  }

  setOnPromote(handler: (id: HeroTemplateId) => void): void {
    this.onPromote = handler;
  }

  setVisible(visible: boolean): void {
    this.el.classList.toggle('visible', visible);
  }

  render(party: Party): void {
    this.list.replaceChildren();
    if (party.recruited.length === 0) {
      const li = document.createElement('li');
      li.textContent = '—';
      li.style.opacity = '0.55';
      this.list.appendChild(li);
      return;
    }
    for (let i = 0; i < party.recruited.length; i++) {
      const m = party.recruited[i]!;
      const li = document.createElement('li');
      li.dataset.templateId = m.templateId;
      const isLeader = i === 0;
      li.className = isLeader ? 'party-member leader' : 'party-member';
      const dot = document.createElement('span');
      dot.className = 'party-dot';
      dot.textContent = isLeader ? '◉' : '○';
      const name = document.createElement('span');
      name.className = 'party-name';
      name.textContent = heroById(m.templateId).name;
      li.appendChild(dot);
      li.appendChild(name);
      this.list.appendChild(li);
    }
  }
}
